import styled from 'styled-components/macro';
import { iconButtonStyles } from '../../common/elements/Button';
import {
  fontSize,
  fontWeight,
  lineHeight,
  neutral,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';
import RoundProfileImage from '../../common/ProfileImage';

export const ListCard = styled.li`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-template-areas: 'avatar name delete';
  align-items: center;
  gap: ${space[3]};
  list-style-type: none;
  margin: 0 0 ${space[3]};
  padding: ${space[3]} ${space[4]};
  border-radius: ${radius.lg};
  color: ${({ theme }) => theme.headerColour};
  box-shadow: ${shadow.sm};
  background: ${neutral.surface};
  background-clip: padding-box;
  /* staff get a solid highlight border, students show the theme gradient through a transparent border */
  border: 1px solid
    ${({ theme, isStaff }) =>
      isStaff ? theme.classroomHighlight : 'transparent'};
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -1px;
    border-radius: inherit;
    background: ${({ theme }) => theme.buttonUpdate};
  }
`;

export const Avatar = styled(RoundProfileImage)`
  grid-area: avatar;
  justify-self: center;
  align-self: center;
  /* avatar box size */
  width: 4rem;
  height: 4rem;
`;

export const StudentName = styled.h3`
  grid-area: name;
  margin: 0;
  font-size: ${fontSize.md};
  font-weight: ${fontWeight.bold};
  line-height: ${lineHeight.tight};
  overflow-wrap: anywhere;
`;

export const DeleteButton = styled.button.attrs({ $tone: 'danger' })`
  ${iconButtonStyles}
  grid-area: delete;
`;

export * from '../../common/elements/Staff';
